import { useModalContext } from '@chakra-ui/react';
import { IconButton } from '../../../../components/action';
import { Box } from '../../../../components/internal';
import { useMultiStyleConfig } from '../../../../utils/use-style-config';
import { jsx as _jsx } from "react/jsx-runtime";
export var BaseModalCloseButton = _ref => {
  var {
    closeButtonAriaLabel = 'Close modal'
  } = _ref;
  var style = useMultiStyleConfig('BaseModal', {});
  var {
    onClose
  } = useModalContext();
  return /*#__PURE__*/_jsx(Box, {
    __css: style['closeButton'],
    children: /*#__PURE__*/_jsx(IconButton, {
      "data-testid": "modal-close-button",
      icon: "close",
      variant: "naked",
      onClick: onClose,
      "aria-label": closeButtonAriaLabel
    })
  });
};
BaseModalCloseButton.displayName = 'BaseModalCloseButton';
//# sourceMappingURL=BaseModalCloseButton.js.map